const fillMediaBase = (mobileValue, desktopValue) => {
  return [mobileValue, ...Array(2).fill(null), desktopValue]
}

const fillMediaTablet = (mobileValue, tabletValue, desktopValue) => {
  return [mobileValue, ...Array(2).fill(null), tabletValue, desktopValue]
}

export { fillMediaBase, fillMediaTablet }
